export default (
  <svg width="100%" height="100%" viewBox="0 0 443 443" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="100%" height="100%" rx="101.104" fill="#2C3E50"></rect>
    <path
      d="M221.5 100C152.635 100 97 155.635 97 224.5C97 293.365 152.635 349 221.5 349C290.365 349 346 293.365 346 224.5C346 155.635 290.365 100 221.5 100ZM221.5 319C168.729 319 127 277.271 127 224.5C127 171.729 168.729 130 221.5 130C274.271 130 316 171.729 316 224.5C316 277.271 274.271 319 221.5 319Z"
      fill="white"
    ></path>
    <circle cx="221.5" cy="224.5" r="40" fill="white"></circle>
  </svg>
);
